var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_vm._l((_vm.columns),function(colKey){return [(_vm.$slots[colKey])?_c('b-col',{key:colKey,attrs:{"cols":_vm.columnAttributes[colKey].cols}},[_vm._t(colKey)],2):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }